import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// AA monogram logo
export const Logo = ({ className = "", onClick }) => (
  <Link to="/" onClick={onClick} data-testid="logo-link" className={`flex items-center gap-3 group ${className}`}>
    <img
      src="/logo-monogram.png"
      alt="The Aesthetics Academy Co"
      className="h-11 md:h-12 w-auto select-none"
      draggable="false"
    />
    <span className="hidden sm:block h-8 w-px bg-white/20" />
    <span className="hidden sm:block font-manrope text-[10px] md:text-[11px] tracking-[0.25em] uppercase text-white/80 leading-tight">
      The Aesthetics<br />Academy Co
    </span>
  </Link>
);

// Primary gold button (sharp corners, pill option)
export const GoldButton = ({ children, pill = true, className = "", ...rest }) => (
  <motion.button
    whileTap={{ scale: 0.96 }}
    className={`relative inline-flex items-center justify-center gap-2 bg-gold text-navy font-manrope font-semibold tracking-[0.15em] uppercase text-xs md:text-sm px-8 py-4 ${
      pill ? "rounded-full" : "rounded-none"
    } overflow-hidden transition-colors duration-300 hover:bg-gold-hover ${className}`}
    {...rest}
  >
    {children}
  </motion.button>
);

// Outline button
export const OutlineButton = ({ children, pill = true, className = "", ...rest }) => (
  <motion.button
    whileTap={{ scale: 0.96 }}
    className={`inline-flex items-center justify-center gap-2 border border-gold/70 text-gold font-manrope font-semibold tracking-[0.15em] uppercase text-xs md:text-sm px-8 py-4 ${
      pill ? "rounded-full" : "rounded-none"
    } transition-colors duration-300 hover:bg-gold hover:text-navy ${className}`}
    {...rest}
  >
    {children}
  </motion.button>
);
